import { Injectable } from '@angular/core';
import { AppSettingService } from '@rd/core/services/app-setting/app-setting.service';
import { CurrencyFormat } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class WestpacAppSettingService extends AppSettingService {
  currencyFormat: CurrencyFormat = 'codeWithSpace';
}
